export enum DashboardAction {
  DashboardReady = 'dashboardReady',
  DashboardSignedIn = 'dashboardSignedIn',
  DashboardSignedOut = 'dashboardSignedOut',
  ExtensionInstalled = 'extensionInstalled',
  ExtensionSignedIn = 'extensionSignedIn',
  ExtensionSignedOut = 'extensionSignedOut',
  IsExtensionInstalled = 'isExtensionInstalled',
  IsExtensionInstalledResponse = 'isExtensionInstalledResponse',
}
